import { featuresItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-heading font-bold text-xl md:text-3xl text-foreground-950 text-center mb-2">
            平台优势
          </h2>
          <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
            为什么选择每日大赛mrds作为你的创作竞技平台
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {featuresItems.map((item, idx) => (
              <div
                key={idx}
                className="flex flex-col items-center text-center p-6 md:p-8 bg-background-50 rounded-xl border border-background-200/70"
              >
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 mb-5">
                  <i className={`${item.icon} text-primary-600 text-2xl md:text-3xl`}></i>
                </div>
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 mb-3">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}